// The wait while the stand's wording arrives, on both lanes.
//
// `aria-busy` and a live region rather than a spinner, because a screen
// reader on a slow venue connection should be told something is happening and
// then told what happened, and this surface is semantic HTML by ruling. After
// a moment it adds the hand-off's "Still asking.", so a slow hall connection
// reads as slow rather than stuck.

import { useEffect, useState, type ReactNode } from "react";

export const STILL_ASKING_MS = 2500;

export function Checking(): ReactNode {
  const [still, setStill] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setStill(true), STILL_ASKING_MS);
    return () => window.clearTimeout(timer);
  }, []);
  return (
    <section>
      <h1>Register</h1>
      <p className="web-lede" aria-live="polite" aria-busy="true">
        Checking what this stand is asking for. This takes a moment on venue wifi.
      </p>
      {/* Its own live region, there from the first paint so the later
          sentence is announced: the busy lede above is still busy. */}
      <p className="web-said" aria-live="polite">
        {still ? "Still asking." : ""}
      </p>
    </section>
  );
}
